import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
export const PageToolbar = ({ showTitle, title, count, children }) => {
    return (React.createElement(Box, { sx: {
            alignItems: { xs: 'start', lg: 'center' },
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            gap: 2,
            whiteSpace: 'noWrap',
        }, "data-test": 'page-toolbar' },
        showTitle && (React.createElement(Stack, { direction: 'row', spacing: 1, alignItems: 'center' },
            React.createElement(Typography, { variant: 'subtitle1', "data-test": 'title' }, title),
            React.createElement(Typography, { variant: 'body2', "data-test": 'count' },
                "(",
                count,
                ")"))),
        children));
};
